import React from 'react';
import styled from 'styled-components';

const UploadLabel = styled.label`
  background-color: steelblue;
  color: white;
  padding: 10px;
  border-radius: 4px;
  cursor: pointer;
`;

export default UploadLabel;



// WEBPACK FOOTER //
// ./src/components/UploadLabel/UploadLabel.js